"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberList = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var NumberList = function NumberList() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 18.25H2.52632V18.875H1.26316V20.125H2.52632V20.75H0V22H3.78947V17H0V18.25ZM1.26316 7H2.52632V2H0V3.25H1.26316V7ZM0 10.75H2.27368L0 13.375V14.5H3.78947V13.25H1.51579L3.78947 10.625V9.5H0V10.75ZM6.81579 3.25C6.53965 3.25 6.31579 3.47386 6.31579 3.75V5.25C6.31579 5.52614 6.53965 5.75 6.81579 5.75H23.5C23.7761 5.75 24 5.52614 24 5.25V3.75C24 3.47386 23.7761 3.25 23.5 3.25H6.81579ZM6.31579 20.25C6.31579 20.5261 6.53965 20.75 6.81579 20.75H23.5C23.7761 20.75 24 20.5261 24 20.25V18.75C24 18.4739 23.7761 18.25 23.5 18.25H6.81579C6.53965 18.25 6.31579 18.4739 6.31579 18.75V20.25ZM6.31579 12.75C6.31579 13.0261 6.53965 13.25 6.81579 13.25H23.5C23.7761 13.25 24 13.0261 24 12.75V11.25C24 10.9739 23.7761 10.75 23.5 10.75H6.81579C6.53965 10.75 6.31579 10.9739 6.31579 11.25V12.75Z"
  }));
};

exports.NumberList = NumberList;